(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[238],{

/***/ 45338:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/park/[park]/[attraction]",
      function () {
        return __webpack_require__(13427);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 13427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Attraction; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/config.jsx
var config = __webpack_require__(43738);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-markdown/lib/react-markdown.js + 129 modules
var react_markdown = __webpack_require__(29655);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./context/app.js
var app = __webpack_require__(40714);
// EXTERNAL MODULE: ./components/global/breadcrumbs.jsx
var global_breadcrumbs = __webpack_require__(43228);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./utils/rideTypes.js
var rideTypes = __webpack_require__(13873);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 3 modules
var transition = __webpack_require__(11355);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/dialog/dialog.js + 9 modules
var dialog = __webpack_require__(7216);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/XIcon.js
var XIcon = __webpack_require__(5506);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 32 modules
var format = __webpack_require__(28582);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./utils/ride-credit.js + 3 modules
var ride_credit = __webpack_require__(64078);
;// CONCATENATED MODULE: ./components/attractions/credit-claim.jsx

/* eslint-disable @next/next/no-img-element */ 







function ClaimCreditPanel(param1) {
    var open = param1.open, setOpen = param1.setOpen, attraction = param1.attraction, mutate = param1.mutate;
    var user = (0,react.useContext)(app/* default */.Z).user;
    var ref = (0,react.useState)(""), currentDate = ref[0], setCurrentDate = ref[1];
    (0,react.useEffect)(function() {
        setCurrentDate((0,format/* default */.Z)(new Date(), "yyyy-MM-dd'T'HH:mm"));
    }, [
        open
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Root */.u.Root, {
        show: open,
        as: react.Fragment,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog */.V, {
            as: "div",
            className: "fixed inset-0 z-30 overflow-hidden",
            onClose: setOpen,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "absolute inset-0 overflow-hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog.Overlay */.V.Overlay, {
                        className: "absolute inset-0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "fixed inset-y-0 right-0 flex max-w-full md:pl-10",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                            as: react.Fragment,
                            enter: "transform transition ease-in-out duration-500 sm:duration-700",
                            enterFrom: "translate-x-full",
                            enterTo: "translate-x-0",
                            leave: "transform transition ease-in-out duration-500 sm:duration-700",
                            leaveFrom: "translate-x-0",
                            leaveTo: "translate-x-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-screen max-w-2xl",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                                    initialValues: {
                                        rideDate: currentDate
                                    },
                                    onSubmit: function(values, param) {
                                        var setSubmitting = param.setSubmitting;
                                        (0,ride_credit/* createRideCredit */.CI)(values, setSubmitting, attraction, setOpen, mutate, user);
                                    },
                                    children: function(param) {
                                        var values = param.values, errors = param.errors, touched = param.touched, handleChange = param.handleChange, handleBlur = param.handleBlur, handleSubmit = param.handleSubmit, setFieldValue = param.setFieldValue, isSubmitting = param.isSubmitting;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("form", {
                                            className: "flex h-full flex-col overflow-y-scroll bg-white shadow-xl",
                                            onSubmit: handleSubmit,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex-1",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "bg-gray-50 px-4 py-6 sm:px-6",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "flex items-start justify-between space-x-3",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "space-y-1",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog.Title */.V.Title, {
                                                                            className: "text-lg font-medium text-gray-900",
                                                                            children: (attraction === null || attraction === void 0 ? void 0 : attraction.Type) === "RESTROOM" ? "Claim Restroom Credit" : "Claim Ride Credit"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "flex h-7 items-center",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                            type: "button",
                                                                            className: "text-gray-400 hover:text-gray-500",
                                                                            onClick: function() {
                                                                                return setOpen(false);
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: "sr-only",
                                                                                    children: "Close panel"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(XIcon/* default */.Z, {
                                                                                    className: "h-6 w-6",
                                                                                    "aria-hidden": "true"
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "space-y-6 py-6 sm:space-y-0 sm:divide-y sm:divide-gray-200 sm:py-0",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                htmlFor: "rideDate",
                                                                                className: "block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2",
                                                                                children: (attraction === null || attraction === void 0 ? void 0 : attraction.Type) === "RESTROOM" ? "Date" : "Date Experienced"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "sm:col-span-2",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                type: "datetime-local",
                                                                                name: "rideDate",
                                                                                id: "rideDate",
                                                                                className: "block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm",
                                                                                onChange: handleChange,
                                                                                onBlur: handleBlur,
                                                                                value: values.rideDate
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: classnames_default()({
                                                                        "space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5": true,
                                                                        "!hidden": (attraction === null || attraction === void 0 ? void 0 : attraction.Type) === "RESTROOM"
                                                                    }),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                htmlFor: "rideTime",
                                                                                className: "block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2",
                                                                                children: "Time of day"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "sm:col-span-2",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                                                name: "rideTime",
                                                                                id: "rideTime",
                                                                                className: "block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm",
                                                                                onChange: handleChange,
                                                                                onBlur: handleBlur,
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                        value: "UNKNOWN",
                                                                                        children: "Unknown"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                        value: "MORNING",
                                                                                        children: "Morning"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                        value: "AFTERNOON",
                                                                                        children: "Afternoon"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                        value: "NIGHT",
                                                                                        children: "Night"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                        value: "EXCLUSIVE",
                                                                                        children: "Exclusive (ERT, Special Event, etc)"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                htmlFor: "ridePosition",
                                                                                className: "block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2",
                                                                                children: (attraction === null || attraction === void 0 ? void 0 : attraction.Type) === "RESTROOM" ? "Number 1 or 2" : "Position"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "sm:col-span-2",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                                                name: "ridePosition",
                                                                                id: "ridePosition",
                                                                                className: "block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm",
                                                                                onChange: handleChange,
                                                                                onBlur: handleBlur,
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                        value: "UNKNOWN",
                                                                                        children: "Unknown"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                        value: "FRONT",
                                                                                        children: (attraction === null || attraction === void 0 ? void 0 : attraction.Type) === "RESTROOM" ? "Number 1" : "Front"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                        value: "MIDDLE",
                                                                                        children: (attraction === null || attraction === void 0 ? void 0 : attraction.Type) === "RESTROOM" ? "Both" : "Middle"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                        value: "BACK",
                                                                                        children: (attraction === null || attraction === void 0 ? void 0 : attraction.Type) === "RESTROOM" ? "Number 2" : "Back"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: classnames_default()({
                                                                        "space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5": true,
                                                                        "!hidden": (attraction === null || attraction === void 0 ? void 0 : attraction.Type) === "RESTROOM"
                                                                    }),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                htmlFor: "rideRow",
                                                                                className: "block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2",
                                                                                children: "Row"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "sm:col-span-2",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                type: "text",
                                                                                name: "rideRow",
                                                                                id: "rideRow",
                                                                                className: "block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm",
                                                                                onChange: handleChange,
                                                                                onBlur: handleBlur
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: classnames_default()({
                                                                        "space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5": true,
                                                                        "!hidden": (attraction === null || attraction === void 0 ? void 0 : attraction.Type) === "RESTROOM"
                                                                    }),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                htmlFor: "rideSide",
                                                                                className: "block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2",
                                                                                children: "Side"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "sm:col-span-2",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                                                name: "rideSide",
                                                                                id: "rideSide",
                                                                                className: "block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm",
                                                                                onChange: handleChange,
                                                                                onBlur: handleBlur,
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                        value: "UNKNOWN",
                                                                                        children: "Unknown"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                        value: "LEFT",
                                                                                        children: "Left"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                        value: "MIDDLE",
                                                                                        children: "Middle"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                        value: "RIGHT",
                                                                                        children: "Right"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex-shrink-0 border-t border-gray-200 px-4 py-5 sm:px-6",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex justify-end space-x-3",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                type: "button",
                                                                className: "rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
                                                                onClick: function() {
                                                                    return setOpen(false);
                                                                },
                                                                children: "Cancel"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                type: "submit",
                                                                className: "inline-flex justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:cursor-not-allowed",
                                                                disabled: isSubmitting,
                                                                children: !isSubmitting ? "Claim Credit" : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                                            className: "-ml-1 mr-3 h-5 w-5 animate-spin text-white",
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            fill: "none",
                                                                            viewBox: "0 0 24 24",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                                                    className: "opacity-25",
                                                                                    cx: "12",
                                                                                    cy: "12",
                                                                                    r: "10",
                                                                                    stroke: "currentColor",
                                                                                    strokeWidth: "4"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                                    className: "opacity-75",
                                                                                    fill: "currentColor",
                                                                                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        "Claiming..."
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        });
                                    }
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/graphql-request/dist/index.js
var graphql_request_dist = __webpack_require__(28687);
;// CONCATENATED MODULE: ./queries/ride-credit.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  query RideCredit($attraction: String!, $user: String!) {\n    rideCreditCount(where: { Attraction: $attraction, User: $user })\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var RIDE_CREDIT_QUERY = (0,graphql_request_dist.gql)(_templateObject());
/* harmony default export */ var queries_ride_credit = (RIDE_CREDIT_QUERY);

;// CONCATENATED MODULE: ./components/attractions/credit.jsx








function Credit(param) {
    var attraction = param.attraction, type = param.type, setOpen = param.setOpen, open = param.open;
    var ref;
    var ref1 = (0,react.useState)(false), creditOpen = ref1[0], setCreditOpen = ref1[1];
    if (!type) {
        type = "OTHER";
    }
    var user = (0,react.useContext)(app/* default */.Z).user;
    var variables = {
        attraction: attraction.id,
        user: user === null || user === void 0 ? void 0 : (ref = user.id) === null || ref === void 0 ? void 0 : ref.toString()
    };
    var ref2 = (0,dist/* default */.ZP)(user ? [
        queries_ride_credit,
        variables
    ] : null), data = ref2.data, error = ref2.error, mutate = ref2.mutate;
    if (!user) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
            className: "overflow-hidden bg-white px-4 py-4 shadow sm:rounded-md sm:px-6",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/register",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "inline-block text-gray-900 hover:underline",
                    children: "Sign Up to track your rides"
                })
            })
        });
    }
    if (error) {
        console.error(error);
    }
    var count = (data === null || data === void 0 ? void 0 : data.rideCreditCount) || 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        className: "overflow-hidden bg-white px-4 py-4 shadow sm:rounded-md sm:px-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "mb-2",
                children: [
                    rideTypes/* default */.Z[type].rideCredit.countLine,
                    " ",
                    count,
                    " ",
                    "time".concat(count === 1 ? "" : "s"),
                    "."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                onClick: function() {
                    return setCreditOpen(true);
                },
                className: "rounded bg-blue-500 py-2 px-4 font-bold text-white hover:bg-blue-700 focus:outline-none focus:ring",
                children: rideTypes/* default */.Z[type].rideCredit.claimCredit
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClaimCreditPanel, {
                open: creditOpen,
                setOpen: setCreditOpen,
                attraction: attraction,
                mutate: mutate
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/global/cover.jsx
var cover = __webpack_require__(16763);
// EXTERNAL MODULE: ./components/throw404.jsx
var throw404 = __webpack_require__(36551);
// EXTERNAL MODULE: ./components/global/attributes.jsx
var global_attributes = __webpack_require__(45033);
// EXTERNAL MODULE: ./components/global/gallery.jsx + 2 modules
var gallery = __webpack_require__(37999);
// EXTERNAL MODULE: ./queries/attraction.js + 1 modules
var attraction = __webpack_require__(12722);
;// CONCATENATED MODULE: ./components/attractions/attraction-details.jsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}















var EditLink = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 673).then(__webpack_require__.bind(__webpack_require__, 32673));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(32673)
            ];
        }
    },
    ssr: false
});
var EditAttractionPanel = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 569).then(__webpack_require__.bind(__webpack_require__, 31569));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(31569)
            ];
        }
    },
    ssr: false
});
function AttractionDetails() {
    var router = (0,next_router.useRouter)();
    var ref4 = (0,react.useContext)(app/* default */.Z), setRecommendedRecentAttraction = ref4.setRecommendedRecentAttraction, setRecommendedRecentPark = ref4.setRecommendedRecentPark, setRecommendedRecentResort = ref4.setRecommendedRecentResort;
    var ref1 = (0,react.useState)(false), editOpen = ref1[0], setEditOpen = ref1[1];
    var variables = {
        slug: router.query.attraction
    };
    var ref2 = (0,dist/* default */.ZP)([
        attraction/* default */.Z,
        variables
    ]), data = ref2.data, error = ref2.error;
    if (error) {
        console.log(error);
    }
    (0,react.useEffect)(function() {
        var ref;
        var attraction = data.attractions[0];
        setRecommendedRecentAttraction(attraction);
        if (attraction === null || attraction === void 0 ? void 0 : attraction.Park) {
            setRecommendedRecentPark(attraction === null || attraction === void 0 ? void 0 : attraction.Park);
        }
        if (attraction === null || attraction === void 0 ? void 0 : (ref = attraction.Park) === null || ref === void 0 ? void 0 : ref.Resort) {
            var ref3;
            setRecommendedRecentResort(attraction === null || attraction === void 0 ? void 0 : (ref3 = attraction.Park) === null || ref3 === void 0 ? void 0 : ref3.Resort);
        }
    }, [
        data.attractions,
        setRecommendedRecentAttraction,
        setRecommendedRecentPark,
        setRecommendedRecentResort, 
    ]);
    if (!Array.isArray(data === null || data === void 0 ? void 0 : data.attractions) || !(data === null || data === void 0 ? void 0 : data.attractions[0])) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(throw404/* default */.Z, {});
    }
    var attraction1 = data.attractions[0];
    var park = attraction1.Park;
    var description = "".concat(attraction1.Name, " is an attraction located in ").concat(park.Name);
    var breadcrumbs = [];
    breadcrumbs.push({
        name: park.Name,
        link: "/park/[park]",
        linkAs: "/park/".concat(park.Slug)
    });
    breadcrumbs.push({
        name: attraction1.Name,
        link: "/park/[park]/[attraction]",
        linkAs: "/park/".concat(park.Slug, "/").concat(attraction1.Slug)
    });
    var CoverPhoto = "";
    var AttractionTitle = "";
    if (attraction1.CoverPhoto || attraction1.MainPhoto) {
        CoverPhoto = /*#__PURE__*/ (0,jsx_runtime.jsx)(cover/* default */.Z, {
            title: attraction1.Name,
            image: attraction1.CoverPhoto || attraction1.MainPhoto
        });
    } else {
        AttractionTitle = /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
            className: "font-serif text-5xl text-gray-800",
            children: attraction1.Name
        });
    }
    var attributes = [];
    if (Array.isArray(attraction1.Manufacturers)) {
        attraction1.Manufacturers.forEach(function(manufacturer) {
            return attributes.push({
                ValueType: "MANUFACTURER",
                Value: manufacturer.Name,
                Link: "/manufacturer/".concat(manufacturer.Slug)
            });
        });
    }
    if (Array.isArray(attraction1.Attribute) && attraction1.Attribute.length) {
        attributes = _toConsumableArray(attributes).concat(_toConsumableArray(attraction1.Attribute));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                        children: [
                            attraction1.Name,
                            " @ ",
                            attraction1.Park.Name,
                            " | Open Coaster"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "".concat(attraction1.Name, " @ ").concat(park.Name)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "https://opencoaster.com/park/".concat(park.Slug, "/").concat(attraction1.Slug)
                    }),
                    attraction1.MainPhoto && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:image",
                                content: "https://images.opencoaster.com/1200x630/".concat(attraction1.MainPhoto.hash).concat(attraction1.MainPhoto.ext)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:image",
                                content: "https://images.opencoaster.com/1200x600/".concat(attraction1.MainPhoto.hash).concat(attraction1.MainPhoto.ext)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:image:width",
                                content: "1200"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:image:height",
                                content: "630"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:image:alt",
                                content: attraction1.MainPhoto.alternativeText ? attraction1.MainPhoto.alternativeText : attraction1.Name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:card",
                                content: "summary_large_image"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EditAttractionPanel, {
                open: editOpen,
                setOpen: setEditOpen,
                attraction: attraction1
            }),
            CoverPhoto,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: "container m-6 mx-auto px-6 sm:px-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_breadcrumbs/* default */.Z, {
                        items: breadcrumbs
                    }),
                    AttractionTitle,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid grid-cols-1 gap-8 lg:grid-cols-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "order-last lg:order-first",
                                children: [
                                    attraction1.Description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "prose mb-3 lg:prose-xl",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_markdown/* ReactMarkdown */.D, {
                                            children: attraction1.Description
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gallery/* default */.Z, {
                                        item: attraction1
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "order-first lg:order-last",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    role: "list",
                                    className: "space-y-3",
                                    children: [
                                        Array.isArray(attraction1.Tags) && attraction1.Tags.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "overflow-hidden bg-white px-4 py-4 shadow sm:rounded-md sm:px-6",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex flex-wrap gap-3",
                                                children: attraction1.Tags.map(function(tag) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "inline-flex items-center rounded-full bg-gray-100 px-3 py-0.5 text-sm font-medium text-gray-800",
                                                        children: tag.Name
                                                    }, "tag-".concat(tag.Slug));
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Credit, {
                                            attraction: attraction1,
                                            type: attraction1.Type
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(global_attributes/* default */.Z, {
                                            attributes: attributes
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(EditLink, {
                                            setEditOpen: setEditOpen
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/park/[park]/[attraction].jsx



var __N_SSG = true;
function Attraction(param) {
    var fallback = param.fallback;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(config/* default */.Z, {
        fallback: fallback,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AttractionDetails, {})
    });
};


/***/ }),

/***/ 12722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ attraction; }
});

// EXTERNAL MODULE: ./node_modules/graphql-request/dist/index.js
var dist = __webpack_require__(28687);
// EXTERNAL MODULE: ./queries/fragments/MainPhoto.js
var MainPhoto = __webpack_require__(20519);
// EXTERNAL MODULE: ./queries/fragments/ParkLite.js
var ParkLite = __webpack_require__(82202);
;// CONCATENATED MODULE: ./queries/fragments/AttractionAttribute.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment Attribute on ComponentAttractionAttribute {\n    __typename\n    ValueType\n    Value\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Attribute = (0,dist.gql)(_templateObject());
/* harmony default export */ var AttractionAttribute = (Attribute);

;// CONCATENATED MODULE: ./queries/attraction.js
function attraction_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function attraction_templateObject() {
    var data = attraction_taggedTemplateLiteral([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  query Attraction($slug: String!) {\n    attractions(where: { Slug: $slug }) {\n      __typename\n      id\n      Slug\n      Name\n      Description\n      Type\n      Park {\n        ...ParkLite\n      }\n      CoverPhoto {\n        ...MainPhoto\n      }\n      MainPhoto {\n        ...MainPhoto\n      }\n      Attribute {\n        ...Attribute\n      }\n      Manufacturers {\n        Name\n        Slug\n      }\n      Gallery {\n        ...MainPhoto\n      }\n      Tags {\n        Name\n        Slug\n      }\n      Location {\n        Latitude\n        Longitude\n      }\n    }\n  }\n"
    ]);
    attraction_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var ATTRACTION_QUERY = (0,dist.gql)(attraction_templateObject(), MainPhoto/* default */.Z, ParkLite/* default */.Z, AttractionAttribute);
/* harmony default export */ var attraction = (ATTRACTION_QUERY);


/***/ }),

/***/ 82202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28687);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(graphql_request__WEBPACK_IMPORTED_MODULE_0__);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ParkLite on Parks {\n    id\n    Name\n    Slug\n    MainPhoto {\n      ...MainPhoto\n    }\n    Resort {\n      id\n      Name\n      Slug\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ParkLite = (0,graphql_request__WEBPACK_IMPORTED_MODULE_0__.gql)(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (ParkLite);


/***/ }),

/***/ 64078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CI": function() { return /* binding */ ride_credit_createRideCredit; },
  "WG": function() { return /* binding */ ride_credit_deleteRideCredit; }
});

// UNUSED EXPORTS: updateRideCredit

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
// EXTERNAL MODULE: ./utils/query.js
var utils_query = __webpack_require__(92233);
// EXTERNAL MODULE: ./node_modules/graphql-request/dist/index.js
var dist = __webpack_require__(28687);
;// CONCATENATED MODULE: ./queries/mutations/createRideCredit.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  mutation RideCredit(\n    $attraction: ID!\n    $rideDate: DateTime\n    $rideTime: ENUM_RIDECREDITS_RIDETIME\n    $ridePosition: ENUM_RIDECREDITS_RIDEPOSITION\n    $rideRow: String\n    $rideSide: ENUM_RIDECREDITS_RIDESIDE\n  ) {\n    createRideCredit(\n      input: {\n        data: {\n          Attraction: $attraction\n          RideDate: $rideDate\n          RideTime: $rideTime\n          RidePosition: $ridePosition\n          RideRow: $rideRow\n          RideSide: $rideSide\n        }\n      }\n    ) {\n      rideCredit {\n        id\n        RideDate\n        RideTime\n        RidePosition\n        RideRow\n        RideSide\n        Attraction {\n          id\n          Name\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var RIDE_CREDIT_MUTATION = (0,dist.gql)(_templateObject());
/* harmony default export */ var createRideCredit = (RIDE_CREDIT_MUTATION);

;// CONCATENATED MODULE: ./queries/mutations/updateRideCredit.js
function updateRideCredit_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function updateRideCredit_templateObject() {
    var data = updateRideCredit_taggedTemplateLiteral([
        "\n  mutation RideCredit(\n    $id: ID!\n    $rideDate: String\n    $rideTime: String\n    $ridePosition: String\n    $rideRow: String\n    $rideSide: String\n  ) {\n    updateRideCredit(\n      input: {\n        where: { id: $id }\n        data: {\n          RideDate: $rideDate\n          RideTime: $rideTime\n          RidePosition: $ridePosition\n          RideRow: $rideRow\n          RideSide: $rideSide\n        }\n      }\n    ) {\n      rideCredit {\n        id\n        RideDate\n        RideTime\n        RidePosition\n        RideRow\n        RideSide\n        Attraction {\n          id\n          Name\n        }\n      }\n    }\n  }\n"
    ]);
    updateRideCredit_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var updateRideCredit_RIDE_CREDIT_MUTATION = (0,dist.gql)(updateRideCredit_templateObject());
/* harmony default export */ var updateRideCredit = ((/* unused pure expression or super */ null && (updateRideCredit_RIDE_CREDIT_MUTATION)));

;// CONCATENATED MODULE: ./queries/mutations/deleteRideCredit.js
function deleteRideCredit_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function deleteRideCredit_templateObject() {
    var data = deleteRideCredit_taggedTemplateLiteral([
        "\n  mutation RideCredit($id: ID!) {\n    deleteRideCredit(input: { where: { id: $id } }) {\n      rideCredit {\n        id\n      }\n    }\n  }\n"
    ]);
    deleteRideCredit_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var RIDE_CREDIT_DELETE_MUTATION = (0,dist.gql)(deleteRideCredit_templateObject());
/* harmony default export */ var deleteRideCredit = (RIDE_CREDIT_DELETE_MUTATION);

;// CONCATENATED MODULE: ./utils/ride-credit.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}






function ride_credit_createRideCredit(values, setSubmitting, attraction, setOpen, mutate) {
    return _createRideCredit.apply(this, arguments);
}
function _createRideCredit() {
    _createRideCredit = _asyncToGenerator(runtime_default().mark(function _callee(values, setSubmitting, attraction, setOpen, mutate) {
        var token, variables;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    token = js_cookie/* default.get */.Z.get("token");
                    setSubmitting(true);
                    variables = {
                        attraction: attraction.id,
                        rideDate: new Date(values.rideDate),
                        rideTime: values.rideTime,
                        ridePosition: values.ridePosition,
                        rideRow: values.rideRow,
                        rideSide: values.rideSide
                    };
                    _ctx.next = 5;
                    return (0,utils_query/* default */.Z)(createRideCredit, {
                        variables: variables,
                        token: token
                    });
                case 5:
                    mutate();
                    setSubmitting(false);
                    setOpen(false);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _createRideCredit.apply(this, arguments);
}
function ride_credit_deleteRideCredit(variables, mutate) {
    return _deleteRideCredit.apply(this, arguments);
}
function _deleteRideCredit() {
    _deleteRideCredit = _asyncToGenerator(runtime_default().mark(function _callee(variables, mutate) {
        var token;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    token = js_cookie/* default.get */.Z.get("token");
                    _ctx.next = 3;
                    return (0,utils_query/* default */.Z)(deleteRideCredit, {
                        variables: variables,
                        token: token
                    });
                case 3:
                    mutate();
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _deleteRideCredit.apply(this, arguments);
}
function ride_credit_updateRideCredit(variables, setCreditPending, mutate) {
    return _updateRideCredit.apply(this, arguments);
}
function _updateRideCredit() {
    _updateRideCredit = _asyncToGenerator(regeneratorRuntime.mark(function _callee(variables, setCreditPending, mutate) {
        var token;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    token = Cookie.get("token");
                    setCreditPending(true);
                    _ctx.next = 4;
                    return query(RIDE_CREDIT_UPDATE_MUTATION, {
                        variables: variables,
                        token: token
                    });
                case 4:
                    mutate();
                    setCreditPending(false);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _updateRideCredit.apply(this, arguments);
}


/***/ }),

/***/ 13873:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var RIDE_TYPES = {
    SHOW: {
        name: "Show",
        rideCredit: {
            countLine: "You've watched",
            againAction: "Watch again?",
            removeAction: "Remove a watch",
            claimCredit: "Claim Watch Credit"
        }
    },
    RIDE: {
        name: "Ride",
        rideCredit: {
            countLine: "You've ridden",
            againAction: "Ride again?",
            removeAction: "Remove a ride",
            claimCredit: "Claim Ride Credit"
        }
    },
    CHARACTER_MEET: {
        name: "Character Meet",
        rideCredit: {
            countLine: "You've met",
            againAction: "Meet again?",
            removeAction: "Remove a meet",
            claimCredit: "Claim Character Meet Credit"
        }
    },
    WALK_THROUGH: {
        name: "Walk Through",
        rideCredit: {
            countLine: "You've walked through",
            againAction: "Walk through again?",
            removeAction: "Remove a walk through",
            claimCredit: "Claim Walk Through Credit"
        }
    },
    PLAYGROUND: {
        name: "Playground",
        rideCredit: {
            countLine: "You've played here",
            againAction: "Play again?",
            removeAction: "Remove a play",
            claimCredit: "Claim Playground Credit"
        }
    },
    TRANSPORTATION: {
        name: "Transportation",
        rideCredit: {
            countLine: "You've ridden",
            againAction: "Ride again?",
            removeAction: "Remove a ride",
            claimCredit: "Claim Transportation Credit"
        }
    },
    STREET_PERFORMANCE: {
        name: "Street Performance",
        rideCredit: {
            countLine: "You've watched",
            againAction: "Watch again?",
            removeAction: "Remove a watch",
            claimCredit: "Claim Street Performance Credit"
        }
    },
    SPECTACULAR: {
        name: "Spectacular",
        rideCredit: {
            countLine: "You've watched",
            againAction: "Watch again?",
            removeAction: "Remove a watch",
            claimCredit: "Claim Spectacular Credit"
        }
    },
    PARADE: {
        name: "Parade",
        rideCredit: {
            countLine: "You've watched",
            againAction: "Watch again?",
            removeAction: "Remove a watch",
            claimCredit: "Claim Parade Credit"
        }
    },
    WATER_SLIDE: {
        name: "Waterslide",
        rideCredit: {
            countLine: "You've slid",
            againAction: "Slide again?",
            removeAction: "Remove a slide",
            claimCredit: "Claim Water Slide Credit"
        }
    },
    SLIDE: {
        name: "Slide",
        rideCredit: {
            countLine: "You've slid",
            againAction: "Slide again?",
            removeAction: "Remove a slide",
            claimCredit: "Claim Slide Credit"
        }
    },
    ANIMAL_EXHIBIT: {
        name: "Animal Exhibit",
        rideCredit: {
            countLine: "You've viewed",
            againAction: "View again?",
            removeAction: "Remove a view",
            claimCredit: "Claim Animal Exhibit Credit"
        }
    },
    RETAIL: {
        name: "Retail",
        rideCredit: {
            countLine: "You've shopped",
            againAction: "Shop again?",
            removeAction: "Remove a shop",
            claimCredit: "Claim Shop Credit"
        }
    },
    RESTROOM: {
        name: "Restroom",
        rideCredit: {
            countLine: "You've gone",
            againAction: "Claim again?",
            removeAction: "Remove a restroom",
            claimCredit: "Claim restroom Credit"
        }
    },
    OTHER: {
        name: "Other",
        rideCredit: {
            countLine: "You've experienced this",
            againAction: "Experience again?",
            removeAction: "Remove an experience",
            claimCredit: "Claim Credit"
        }
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (RIDE_TYPES);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [533,269,529,486,582,263,774,888,179], function() { return __webpack_exec__(45338); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);